import React from 'react'
import styled from 'styled-components'

import { Fonts } from 'components/base-ui'
import { displayPrice2Digit } from 'helpers'
import { useTranslation } from 'react-i18next'
import { TemporaryOrderWithPromotionQuery } from 'graphQL/dinein/generate/operations'
import { LANGUAGES } from 'helpers/language'

interface SummaryOrderProps {
  lineItemTotalSatangs?: number
  adjustments: TemporaryOrderWithPromotionQuery['temporaryOrderWithPromotion']['adjustments']
  totalSatangs?: number
}

const SummaryOrder = ({ lineItemTotalSatangs, adjustments, totalSatangs }: SummaryOrderProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  return (
    <>
      {typeof lineItemTotalSatangs === 'number' && (
        <Row>
          <DetailItem>
            <TitleRegular>{t('dineInFoodPrice')}</TitleRegular>
            <TitleRegular>{displayPrice2Digit(lineItemTotalSatangs / 100)}</TitleRegular>
          </DetailItem>
        </Row>
      )}
      {adjustments.length > 0 && (
        <Row>
          {adjustments.map((adjustment) => {
            const { id, amountSatangs, labelEn, labelTh } = adjustment
            const label = language === LANGUAGES.TH ? labelTh : labelEn ? labelEn : t('checkoutSummaryDiscounts')
            return (
              <Adjustments key={id} className="adjustment-item">
                <TitleRegular className="adjustment-label">{label}</TitleRegular>
                <AdjustmentTotal className="adjustment-discount">
                  {amountSatangs < 0
                    ? `-${displayPrice2Digit(amountSatangs / 100).replace('-', '')}`
                    : `${displayPrice2Digit(amountSatangs / 100)}`}
                </AdjustmentTotal>
              </Adjustments>
            )
          })}
        </Row>
      )}
      {typeof totalSatangs === 'number' && (
        <Row>
          <DetailItem>
            <Fonts.Medium>{t('dineInTotal')}</Fonts.Medium>
            <Fonts.Medium>{displayPrice2Digit(totalSatangs / 100)}</Fonts.Medium>
          </DetailItem>
        </Row>
      )}
    </>
  )
}

export default SummaryOrder

const Row = styled.div`
  position: relative;

  &::before {
    content: '';
    display: block;
    height: 1px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    background-color: ${({ theme }) => theme.colors.baseGrey};
    opacity: 0.5;
  }
`

const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
`

const Adjustments = styled(DetailItem)`
  color: ${({ theme }) => theme.colors.successDark};

  &:not(:last-child) {
    padding-bottom: 0;
  }
`

const TitleRegular = styled(Fonts.BaseTitleRegular)`
  padding: 3px;
`

const AdjustmentTotal = styled(Fonts.BaseTitleRegular)`
  padding: 3px;
  white-space: nowrap;
`
